import { useCallback, useState } from "react";
import { IPrintRequest } from "../../../../types";
import UserReportService from "../../../../../../../../../../services/accounts/userReportGeneration";
import { useOpenProgressModal } from "../../../../../../../../../../lib/hooks/useOpenProgressModal";
import { useDownloadReport } from "../../../../../../../../../../lib/hooks/useDownloadReport";
import { SUCCESS_PDF_DOWNLOAD } from "../../../../../../../../../../lib/constants";

export const usePrint = (
  request: IPrintRequest,
  accountNumber: number,
  cancel: () => void,
) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { download } = useDownloadReport(setIsLoading);

  const { openModal } = useOpenProgressModal(
    `Generating Tax Report`,
    `Generating Tax Report failed`,
    (id?: string) => {
      download(UserReportService, id);
    },
    {
      customMsg: SUCCESS_PDF_DOWNLOAD,
    },
  );

  const print = useCallback(async () => {
    try {
      setIsLoading(true);

      const id: string = await UserReportService.generateHistoryReport(
        request,
        accountNumber,
        "Report1098",
      );

      openModal(id);

      cancel();

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [request, accountNumber, openModal, cancel]);

  return { isLoading, print };
};
